<template>
  <div class = "st-table">
    <el-row :gutter="16" type="flex" justify=start>
      <el-card shadow="always" style="width: 100%">
        <el-form :model="query" label-width="80px" label-colon>
          <el-row :gutter="16">
            <el-col :span="6">
              <el-form-item
                label="Name"
                :span="11"
              >
                <el-select
                  v-model="query.user"
                  filterable
                  clearable
                  :loading="loading1"
                >
                  <el-option
                    v-for="(option) in options.users"
                    :value="option.value"
                    :key="option.label"
                    :label="option.label"
                    >
                    {{option.label}}
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Type" :span="11">
                <el-select
                  v-model="query.category"
                  filterable
                  clearable
                  :loading="loading1"
                >
                  <el-option
                    v-for="(option, index) in options.categories"
                    :value="option.value"
                    :key="index"
                  >{{ option.label }}</el-option
                  >
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Date" :span="11">
                <el-date-picker
                  v-model="query.operationDate"
                  type="daterange"
                  align="right"
                  range-separator="to"
                  :editable="false"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" :gutter="16">
            <el-col :span="6">
              <el-button type="text" class="btn" @click="handleReset">
                Reset
              </el-button>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" class="btn" @click="getAttendances">
                Search
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </el-row>
    <br/>
    <el-row :gutter="16">
      <el-card shadow="always" title="Weekly Report" style="width: 100%">
        <el-form>
          <el-table
            :data="attList" border style="width: 100%">
            <el-table-column
              prop="fullName"
              label="Name"
            >
            </el-table-column>
            <el-table-column
              prop="day"
              label="Date"
            >
            </el-table-column>
            <el-table-column
              prop="category"
              label="Type"
            >
              <template slot-scope="scope">
<!--                <input type="text"-->
<!--                       v-model="patchItem.category"-->
<!--                       v-if="isEdit === scope.$index"-->
<!--                />-->
                <el-select
                  v-model="patchItem.category"
                  filterable
                  remote
                  clearable
                  v-if="isEdit === scope.$index"
                >
                  <el-option
                    v-for="(option, index) in options.categories"
                    :value="option.value"
                    :label="option.label"
                    :key="index"
                  >{{ option.label }}</el-option
                  >
                </el-select>
                <span v-else>{{scope.row.category}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="time"
              label="Period"
            >
              <template slot-scope="scope">
                <input type="text"
                       v-model="patchItem.time"
                       v-if="isEdit === scope.$index"
                />
                <span v-else>{{scope.row.time}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="comment"
              label="Notes"
            >
              <template slot-scope="scope">
                <input type="text"
                       v-model="patchItem.comment"
                       v-if="isEdit === scope.$index"
                />
                <span v-else>{{scope.row.comment}}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="Action"
              width="180">
              <template slot-scope="scope">
                <div v-if="isEdit === scope.$index">
                  <el-button
                    size="small"
                    type="primary"
                    plain
                    @click="saveAttendance(scope.$index, scope.row)">
                    Save
                  </el-button>
                  <el-button
                    size="small"
                    plain
                    @click="isEdit = -99">
                    Cancel
                  </el-button>
                </div>
                <div v-else>
                  <el-button
                    type="primary"
                    size="small"
                    style="margin-right: 5px"
                    @click="handleEdit(scope.$index, scope.row)">
                    Edit
                  </el-button>
                  <el-button
                    size="small"
                    type="danger"
                    @click="deleteAttendance(scope.$index, scope.row)"
                  >
                    Delete
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page.sync="query.currentPage"
            :page-sizes="[10,20,50]"
            :total="query.totalPage"
            :page-size.sync="query.pageSize"
            prev-text="Previous"
            next-text="Next"
            style="margin-top: 4px"
            show-total
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-form>

      </el-card>
    </el-row>
    <br/>

  </div>

</template>

<script>
import attendanceApi from '@/api/attendance.js';
import userApi from '@/api/user.js'


export default {
  name: "attList",
  data() {
    return {
      formItem: {
        user: '',
        category: '',
        comment: '',
        user_info: '',
        id: '',
      },
      patchItem: {
        id: '',
        category: '',
        time: '',
        comment: '',
      },
      attList: [],
      options: {
        users:[],
        categories:[
          {
            value: 'Time_Off_Request_PTO',
            label: 'Time Off Request – PTO',
          },
          {
            value: 'Time_Off_Request_UPTO',
            label: 'Time Off Request – UPTO',
          },
          {
            value: 'Jury_Duty',
            label: 'Jury Duty',
          },
          {
            value: 'BEREAVEMENT',
            label: 'BEREAVEMENT',
          },
        ],
      },
      loading1: false,
      editIndex: -1,
      isEdit: -99,
      role: '',
      query: {
        user: '',
        category: '',
        attDate:'',
        currentPage: 1,
        pageSize: 10,
        totalPage: 0,
      },
    }
  },
  computed: {
    userId() {
      return this.$store.getters.userid;
    },
    userName() {
      return this.$store.getters.username;
    },
    userRole() {
      return this.$store.getters.userRole;
    }
  },
  // created() {
  //   this.getUser()
  // },
  methods: {
    // getUser() {
    //   this.userRole = this.$store.getters.userRole;
    //   this.query.user = this.$store.getters.username;
    // },
    handleEdit(index, row) {
      this.patchItem.category = row.category
      this.patchItem.time = row.time
      this.patchItem.comment = row.comment
      this.isEdit = index
    },
    getAttendances() {
      let para = {}
      if (this.query.operationDate) {
        para['date_from'] = this.query.operationDate[0]
        para['date_to'] = this.query.operationDate[1]
      }
      para['offset'] = this.query.pageSize * (this.query.currentPage -1)
      para['limit'] = this.query.pageSize
      if (this.query.user) {
        para['user_id'] = this.query.user
      }
      if (this.query.category) {
        para['category'] = this.query.category
      }
      attendanceApi.getAttList(para).then(
        res => {
          this.attList = res.data.data
          this.query.totalPage = res.data.total
        }
      )
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getAttendances()
      // 在此刷新数据
    },
    handleCurrentChange(val){
      this.query.currentPage = val
      this.getAttendances()
    },
    saveAttendance(index, row) {
      let para = {id: row.id}
      let data = this.patchItem
      data['description'] = this.patchItem.category
      data['time'] = this.patchItem.time
      data['percentage'] = this.patchItem.percentage
      attendanceApi.patchAtt(para, data).then(resp=>{
        this.$message.success(
          {
            message: resp['msg'],
            type: "success"
          }
        )
        this.getAttendances()
      })
      this.isEdit = -99
    },
    deleteAttendance(index, row) {
      this.$confirm('Delete the attendance, continue?', 'Tips', {
        type: 'warning',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
      }).then(() => {
        let para = { id: row.id }
        attendanceApi.deleteAtt(para).then(resp => {
          this.$message.success({
            message: resp['msg'],
            type: "success"
          })
          this.getAttendances()
        })
      })
    },
    handleReset() {
      this.query.category = null
      this.query.operationDate = null
      this.query.user = null
    },
    getSelects() {
      userApi.getUsers().then(res=> {
        let users = res.data
        for (let user of users) {
          this.options.users.push({value: user.id, label: user["fullName"]})
        }
        })
    }
  },
  mounted() {
    this.getSelects()
  }
}
</script>


<style lang="scss" scoped>
.st-table {
  padding:10px
}

</style>
